module.exports = __webpack_public_path__ + "static/media/route_lined.8880b008.svg";